var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 395.448,
    height: 89.738,
    viewBox: "0 0 395.448 89.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 57.798,
    y1: -7.008,
    x2: 209.555,
    y2: 59.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36c1da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3889c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 61.59,
    y1: -15.698,
    x2: 213.347,
    y2: 50.535,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.334,12.128H40.624v76.4H29.71v-76.4H0v-9.7H70.334Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.653,34.561a27.451,27.451,0,0,0-14.128,4.123,21.035,21.035,0,0,0-8.67,10.794V88.525H71.184v-63.3h9.944V39.9a29.84,29.84,0,0,1,8.61-10.61,21.409,21.409,0,0,1,11.4-4.548H103.2a7.539,7.539,0,0,1,1.455.122Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,89.738a32.254,32.254,0,0,1-13.1-2.607,30.956,30.956,0,0,1-10.187-7.095,32.322,32.322,0,0,1-6.608-10.489A34.246,34.246,0,0,1,109.5,56.875a33.786,33.786,0,0,1,2.364-12.612,31.7,31.7,0,0,1,30.013-20.131A30.775,30.775,0,0,1,171.288,44.2a33.946,33.946,0,0,1,2.244,12.187q0,1.335-.06,2.426a13.525,13.525,0,0,1-.182,1.7H120.78a24.563,24.563,0,0,0,2.184,8.61,22.134,22.134,0,0,0,4.729,6.67,21.791,21.791,0,0,0,6.61,4.366,19.711,19.711,0,0,0,7.82,1.577,20.81,20.81,0,0,0,5.7-.789,24.717,24.717,0,0,0,5.213-2.122,18.113,18.113,0,0,0,4.306-3.274,13.373,13.373,0,0,0,2.849-4.366l9.217,2.546a23.254,23.254,0,0,1-4.306,6.428,28.529,28.529,0,0,1-6.305,5.033,32.458,32.458,0,0,1-7.943,3.334A33.88,33.88,0,0,1,141.76,89.738ZM163.466,52.63a22.829,22.829,0,0,0-2.242-8.307,22.283,22.283,0,0,0-4.73-6.486,21.682,21.682,0,0,0-22.616-4.186,20.623,20.623,0,0,0-6.61,4.246,21.419,21.419,0,0,0-4.606,6.488,23.785,23.785,0,0,0-2.124,8.245Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.657,0h10.671V72.154a7.734,7.734,0,0,0,1.88,5.518,6.884,6.884,0,0,0,5.275,2,14.125,14.125,0,0,0,3.154-.425,25.617,25.617,0,0,0,3.394-1.03l1.7,8.61a34.894,34.894,0,0,1-6.307,1.819,33.236,33.236,0,0,1-6.426.728q-6.185,0-9.762-3.517t-3.578-9.823Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.109,89.738a32.259,32.259,0,0,1-13.1-2.607,30.952,30.952,0,0,1-10.186-7.095,32.288,32.288,0,0,1-6.608-10.489,34.247,34.247,0,0,1-2.365-12.672,33.787,33.787,0,0,1,2.365-12.612,31.7,31.7,0,0,1,30.012-20.131A30.779,30.779,0,0,1,277.637,44.2a33.968,33.968,0,0,1,2.244,12.187q0,1.335-.06,2.426a13.3,13.3,0,0,1-.183,1.7H227.129a24.519,24.519,0,0,0,2.184,8.61,22.131,22.131,0,0,0,4.728,6.67,21.816,21.816,0,0,0,6.61,4.366,19.72,19.72,0,0,0,7.821,1.577,20.8,20.8,0,0,0,5.7-.789,24.7,24.7,0,0,0,5.214-2.122,18.128,18.128,0,0,0,4.3-3.274,13.376,13.376,0,0,0,2.85-4.366l9.216,2.546a23.273,23.273,0,0,1-4.305,6.428,28.535,28.535,0,0,1-6.306,5.033,32.45,32.45,0,0,1-7.942,3.334A33.886,33.886,0,0,1,248.109,89.738ZM269.815,52.63a22.85,22.85,0,0,0-2.243-8.307,22.264,22.264,0,0,0-4.73-6.486,21.681,21.681,0,0,0-22.615-4.186,20.613,20.613,0,0,0-6.61,4.246,21.439,21.439,0,0,0-4.607,6.488,23.83,23.83,0,0,0-2.124,8.245Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7,88.525H336.026V53.115q0-10.187-3.092-14.793t-9.4-4.609a17.969,17.969,0,0,0-6.548,1.273,25.96,25.96,0,0,0-6.185,3.456,23.994,23.994,0,0,0-5.093,5.215,22.281,22.281,0,0,0-3.274,6.669v38.2H291.763v-63.3h9.7V38.806a27.83,27.83,0,0,1,10.853-10.671,30.925,30.925,0,0,1,15.461-4,18.7,18.7,0,0,1,9.1,2,15.452,15.452,0,0,1,5.821,5.579,24.857,24.857,0,0,1,3.091,8.427,57.286,57.286,0,0,1,.91,10.551Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.448,85.372q-.974.487-2.547,1.152t-3.577,1.334a31.529,31.529,0,0,1-4.366,1.092,27.837,27.837,0,0,1-4.911.425,16.2,16.2,0,0,1-10.066-3.214q-4.245-3.212-4.244-10V33.591h-8.609V25.224h8.609V4.123h10.672v21.1H390.6v8.367H376.409V72.883a6.616,6.616,0,0,0,2.3,5.093,7.759,7.759,0,0,0,4.851,1.575,15.531,15.531,0,0,0,5.76-1.03,24.861,24.861,0,0,0,3.577-1.637Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,12.128v-9.7h9.457v9.7Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5,12.128v-9.7h9.456v9.7Z",
    fill: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c28b2678872589991d0f535ef0b1551d.svg";
export { ForwardRef as ReactComponent };